import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAuth } from 'firebase/auth'
import { getFirestore, doc, getDoc, getDocs, query, where, collection, limit } from 'firebase/firestore'
import { db } from '../firebase/init'
import { profileStore } from '@/store/profile';

// ------------ Public Views ------------
import LandingView from '../views/public/LandingView.vue'
import StoryLibrary from '../views/public/StoryLibrary.vue'
import LessonLibrary from '../views/public/LessonLibrary.vue'
import IdeaLibrary from '../views/public/IdeaLibrary.vue'
import GameLibrary from '../views/public/GameLibrary.vue'
import LoginView from '../views/public/LoginView.vue'
import LostView from '../views/public/LostView.vue'
import GamePlayer from '../views/public/GamePlayer.vue'
import StoryPlayer from '../views/public/StoryPlayer.vue'
import LessonPlayer from '../views/public/LessonPlayer.vue'
import IdeaPlayer from '../views/public/IdeaPlayer.vue'
import ConundrumLibrary from '../views/public/ConundrumLibrary.vue'
import ConundrumPlayer from '../views/public/ConundrumPlayer.vue'
// ------------ Private Views ------------
import RealmDashboard from '../views/private/RealmDashboard.vue'
import RealmAccount from '../views/private/RealmAccount.vue'
import RealmGuild from '../views/private/RealmGuild.vue'
import RealmStory from '../views/private/RealmStory.vue'
import RealmLesson from '../views/private/RealmLesson.vue'
import RealmIdea from '../views/private/RealmIdea.vue'
import RealmGame from '../views/private/RealmGame.vue'
import RealmChat from '../views/private/RealmChat.vue'
import RealmConundrum from '../views/private/RealmConundrum.vue'
// ------------ Admin Views ------------
import AdminDashboard from '../views/admin/Dashboard.vue'
import AdminUsers from '../views/admin/Users.vue'
import AdminRealms from '../views/admin/Realms.vue'
import AdminConundrums from '../views/admin/Conundrums.vue'
import AdminUsernames from '../views/admin/Usernames.vue'
import AdminCocoro from '../views/admin/Cocoro.vue'

// import UsernameCreator from '../views/admin/UsernameCreator.vue'
// import ConundrumAstra from '../views/admin/ConundrumAstra.vue'
// import ConundrumReview from '../views/admin/ConundrumReview.vue'
// import ConundrumAutomate from '../views/admin/ConundrumAutomate.vue'
// import ConundrumExperiments from '../views/admin/ConundrumExperiments.vue'

// ------------ Experimental Views ------------
import ExperimentalGameCreator from '../views/private/ExperimentalGameCreator.vue'

Vue.use(VueRouter)

const routes = [
  // ---------------------- Public Routes ----------------------
  {
    path: '',
    name: 'LandingView',
    component: LandingView,
    meta: {
      scope: 'public',
      title: 'Welcome to the Ideaverse',
    }
  },
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView,
    meta: {
      scope: 'public',
      title: 'Login to your Account',
    }
  },
  {
    path: '/stories',
    name: 'StoryLibrary',
    component: StoryLibrary,
    meta: {
      scope: 'public',
      title: 'Story Library',
    }
  },
  {
    path: '/lessons',
    name: 'LessonLibrary',
    component: LessonLibrary,
    meta: {
      scope: 'public',
      title: 'Lesson Library',
    }
  },
  {
    path: '/ideas',
    name: 'IdeaLibrary',
    component: IdeaLibrary,
    meta: {
      scope: 'public',
      title: 'Idea Library',
    }
  },
  {
    path: '/conundrums',
    name: 'ConundrumLibrary',
    component: ConundrumLibrary,
    meta: {
      scope: 'public',
      title: 'Conundrum Library',
    }
  },
  {
    path: '/games',
    name: 'GameLibrary', 
    component: GameLibrary,
    meta: {
      scope: 'public',
      title: 'Game Library',
    }
  },
  {
    path: '/game/:id',
    name: 'GamePlayer',
    component: GamePlayer,
    meta: {
      scope: 'public',
      title: 'Game Player',
    }
  },
  {
    path: '/story/:id',
    name: 'StoryPlayer',
    component: StoryPlayer,
    meta: {
      scope: 'public',
      title: 'Story Player',
    }
  },
  {
    path: '/lesson/:id',
    name: 'LessonPlayer',
    component: LessonPlayer,
    meta: {
      scope: 'public',
      title: 'Lesson Player',
    }
  },
  {
    path: '/idea/:id',
    name: 'IdeaPlayer',
    component: IdeaPlayer,
    meta: {
      scope: 'public',
      title: 'Idea Player',
    }
  },
  {
    path: '/conundrum/:id',
    name: 'ConundrumPlayer',
    component: ConundrumPlayer,
    meta: {
      scope: 'public',
      title: 'Conundrum Player',
    }
  },
  // ---------------------- Realm Routes ----------------------
  {
    path: '/realm',
    name: 'RealmDashboard',
    component: RealmDashboard,
    meta: {
      scope: 'private',
      title: 'Realm Dashboard',
    }
  },
  {
    path: '/realm/account',
    name: 'RealmAccount',
    component: RealmAccount,
    meta: {
      scope: 'private',
      title: 'Realm Account',
    }
  },
  {
    path: '/realm/guild',
    name: 'RealmGuild',
    component: RealmGuild,
    meta: {
      scope: 'private',
      title: 'Realm Guild',
    }
  },
  {
    path: '/realm/chat/:chatId?',
    name: 'RealmChat',
    component: RealmChat,
    meta: {
      scope: 'private',
      title: 'Realm Chat',
    }
  },
  // ---------------------- Editor Routes ----------------------
  {
    path: '/realm/game/:id',
    name: 'RealmGame',
    component: RealmGame,
    meta: {
      scope: 'private',
      title: 'Realm Game',
    }
  },
  {
    path: '/realm/story/:id',
    name: 'RealmStory',
    component: RealmStory,
    meta: {
      scope: 'private',
      title: 'Realm Story',
    }
  },
  {
    path: '/realm/lesson/:id',
    name: 'RealmLesson',
    component: RealmLesson,
    meta: {
      scope: 'private',
      title: 'Realm Lesson',
    }
  },
  {
    path: '/realm/idea/:id',
    name: 'RealmIdea',
    component: RealmIdea,
    meta: {
      scope: 'private',
      title: 'Realm Idea',
    }
  },
  {
    path: '/realm/conundrum/:id',
    name: 'RealmConundrum',
    component: RealmConundrum,
    meta: {
      scope: 'private',
      title: 'Realm Conundrum',
    }
  },
  // ---------------------- Experimental Routes ----------------------
  {
    path: '/realm/experimental/game-creator',
    name: 'ExperimentalGameCreator',
    component: ExperimentalGameCreator,
    meta: {
      scope: 'private',
      title: 'Experimental Game Creator',
    }
  },
  // ---------------------- Admin Routes ----------------------
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      scope: 'admin',
      title: 'Admin - Dashboard',
    }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: AdminUsers,
    meta: {
      scope: 'admin',
      title: 'Admin - Users',
    }
  },
  {
    path: '/admin/conundrums',
    name: 'AdminConundrums',
    component: AdminConundrums,
    meta: {
      scope: 'admin',
      title: 'Admin - Conundrum Creator',
    }
  },
  {
    path: '/admin/realms',
    name: 'AdminRealms',
    component: AdminRealms,
    meta: {
      scope: 'admin',
      title: 'Admin - Realm Creator',
    }
  },
  {
    path: '/admin/usernames',
    name: 'AdminUsernames',
    component: AdminUsernames,
    meta: {
      scope: 'admin',
      title: 'Admin - Usernames',
    }
  },
  {
    path: '/admin/cocoro',
    name: 'AdminCocoro',
    component: AdminCocoro,
    meta: {
      scope: 'admin',
      title: 'Admin - Cocoro',
    }
  },
  // ---------------------- System Routes ----------------------
  {
    path: '*',
    name: 'Lost', 
    component: LostView,
    meta: {
      scope: 'public',
      title: 'Lost',
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve(async (to, from, next) => {
  let user = getAuth().currentUser;
  let profile = await profileStore.fetchProfile() || {};

  // ------------ Check Username ------------
  // Only redirect if we have a user AND successfully fetched a profile but username is missing
  if (user && profile && to.name !== 'RealmDashboard' && !profile.username) {
    next({ name: 'RealmDashboard' });
    return;
  }
  
  switch (to.meta.scope) {
    // ---------------------- Public ----------------------
    case 'public':
      // Redirect from login page
      if (to.name === 'LoginView' && user) {
        next({ name: 'RealmDashboard' });
        break;
      }
      next();
      break;

    // ---------------------- Private ----------------------
    case 'private':
      if (user) {
        next();
      } else {
        next({ name: 'LoginView' });
      }
      break;

    // ---------------------- Admin ----------------------
    case 'admin':
      console.log('Accessing admin route');
      // There are only three admins (socratesgx@gmail.com, aaron@farrindustries.com, and aaronfarr@gmail.com)
      if (user && (user.email === 'socratesgx@gmail.com' || user.email === 'aaron@farrindustries.com' || user.email === 'aaronfarr@gmail.com')) {
        next();
      } else {
        next({ name: 'LandingView' });
      }
      break;

    // ---------------------- Default ----------------------
    default:
      console.log('Default route');
      next();
  }
});

router.afterEach((to) => {
  document.title = (to.meta.title + ' | Ideaverse' || 'Ideaverse')
  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute('content', to.meta.description || 'Default Description');
  }
});

export default router